import React, { useCallback, useState } from 'react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, IconButton, TableCell, TableRow } from '@mui/material'

import Details from './Details'
import { UsersQuery } from '../../../../__generated__/graphql'
import { getSqlDateTimeFromIsoString } from '../../../../utils/dateHelpers'

export default function Row({
  user,
}: {
  user: Exclude<UsersQuery['users'], null | undefined>['items'][0]
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleClick = useCallback(
    () => setIsOpen((currentIsOpen) => !currentIsOpen),
    [],
  )

  // The server-side GraphQL type for AdminUser is incorrect -- id should
  // always be present, not just email
  if (!user?.id) {
    return null
  }
  let anonymousId = user.anonymousId
  if (
    !anonymousId &&
    user.anonymousUserIds &&
    user.anonymousUserIds.length > 0
  ) {
    anonymousId = user.anonymousUserIds[0]
  }
  const getTrialStatus = () => {
    if (user.hasActiveTrial)
      return `Active (${user.trialPlatform || 'Unknown'})`
    if (user.trialExpiresOn) return 'Expired'
    return 'None'
  }
  const trialStatus = getTrialStatus()

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton onClick={handleClick} size="small">
            {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <a
            href={`${window.POSTHOG_URL}${anonymousId}`}
            rel="noreferrer"
            target="_blank"
          >
            {user.id}
          </a>
        </TableCell>
        <TableCell>{user.email}</TableCell>
        <TableCell>{user.name}</TableCell>
        <TableCell>{getSqlDateTimeFromIsoString(user.registeredOn)}</TableCell>
        <TableCell>{getSqlDateTimeFromIsoString(user.planExpiresOn)}</TableCell>
        <TableCell>{trialStatus}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={7} sx={{ paddingBottom: 0, paddingTop: 0 }}>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Details id={user.id} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}
